import truckFast from '/images/icons/truck-fast.svg?raw';
import cloudDownload from '/images/icons/cloud-download.svg?raw';
import triangleWarning from '/images/icons/triangle-warning.svg?raw';
import userLock from '/images/icons/user-lock.svg?raw';
import rewardsStar from '/images/icons/rewards-star.svg?raw';
import graduationCap from '/images/icons/graduation-cap.svg?raw';
import calendar from '/images/icons/calendar.svg?raw';

import type { LegacyIconName } from './lt-icon.config';

export const CUSTOM_ICON_SVG: Record<LegacyIconName, string> = {
  truck: truckFast,
  'cloud-download': cloudDownload,
  'triangle-warning': triangleWarning,
  'user-lock': userLock,
  'rewards-star': rewardsStar,
  'graduation-cap': graduationCap,
  calendar
};
